import teachingCenter from "../../api/teachingCenter";
import pluginCenter from "@/api/pluginCenter";
import request from "@/helpers/request";

const state = {
    classifyListLoading: false,
    classifyList: {},

    classSubjectListLoading: false,
    classSubjectList: {},
    classSubjectListFilter: {},

    lessonVerifyResponseListLoading: false,
    lessonVerifyResponseList: {},
    lessonVerifyResponseListFilter: {
        states: 1,
    },

    approvalModalVisible: false,

    productListLoading: false,
    productListFilter: {},
    productList: {},

    // 课包分类
    productCategoryListLoading: false,
    productCategoryListFilter: {},
    productCategoryList: [],

    selectSeriesModalVisible: false,
    seriesList: {},
    seriesListLoading: false,
    seriesListFilter: {},
    productSubjects: [],
    //   自定义系列选择课程
    selectCourseModalVisible: false,
    courseListLoading: false,
    courseListFilter: {},
    courseList: {},
    // 选择试卷列表弹窗
    selectExamModalVisible: false,
    examListLoading: false,
    examListFilter: {},
    examList: {},
    // 试卷内容列表弹窗
    examContentListModalVisible: false,
    selectQuestionExamModalVisible: false,
    //   系列内容列表弹窗
    subjectContentListModalVisible: false,
    subjectContentListLoading: false,
    subjectContentListFilter: {},
    subjectContentList: {},
    jumpWay: 0,

    //   标签
    tagListLoading: false,
    tagList: {},
    tagListFilter: {},
    isBack: false,
    //   标签分类
    tagCategoryListLoading: false,
    tagCategoryList: {},
    tagCategoryListFilter: {},
    addTagAttributeVisible: false,
    rowDetails: {},
};

const getters = {};
const mutations = {
    setData(state, {key, value}) {
        state[key] = value;
    },
    clearFilter(state) {
        state.classSubjectListFilter = {};
        state.lessonVerifyResponseListFilter = {
            states: 1,
        };
        state.seriesListFilter = {};
        state.productListFilter = {};
        state.courseListFilter = {};
        state.subjectContentListFilter = {};
        state.examListFilter = {};
    },
};
const actions = {
    // eslint-disable-next-line no-empty-pattern
    async getClassTree({commit}, payload) {
        commit("setData", {key: "classifyListLoading", value: true});
        const res = await teachingCenter.getClassTree(payload);
        commit("setData", {key: "classifyList", value: res});
        commit("setData", {key: "classifyListLoading", value: false});
        return res
    },
    // eslint-disable-next-line no-empty-pattern
    async saveClassTree({}, payload) {
        await teachingCenter.saveClassTree(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteClassTree({}, payload) {
        await teachingCenter.deleteClassTree(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getClassSubjectList({commit}, payload) {
        commit("setData", {key: "classSubjectListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.classSubjectListFilter,
                ...payload,
            };
            const res = await teachingCenter.getClassSubjectList.getList(params);
            commit("setData", {key: "classSubjectList", value: res.data});
        } finally {
            commit("setData", {key: "classSubjectListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getSeriesList({commit}, payload) {
        commit("setData", {key: "seriesListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.seriesListFilter,
                ...payload,
            };
            const res = await teachingCenter.getClassSubjectInfoList.getList(params);
            commit("setData", {key: "seriesList", value: res.data});
            return res;
        } finally {
            commit("setData", {key: "seriesListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveClassSubject({}, payload) {
        await teachingCenter.saveClassSubject(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteClassSubject({}, payload) {
        await teachingCenter.deleteClassSubject(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deployClassSubject({}, payload) {
        await teachingCenter.deployClassSubject(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonVerifyResponseList({commit}, payload) {
        commit("setData", {key: "lessonVerifyResponseListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.lessonVerifyResponseListFilter.dateRange &&
                state.lessonVerifyResponseListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.lessonVerifyResponseList.size,
                    ...state.lessonVerifyResponseListFilter,
                    ...payload,
                    startTime: state.lessonVerifyResponseListFilter.dateRange
                        ? state.lessonVerifyResponseListFilter.dateRange[0]
                        : null,
                    endTime: state.lessonVerifyResponseListFilter.dateRange
                        ? state.lessonVerifyResponseListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.lessonVerifyResponseList.size,
                    ...state.lessonVerifyResponseListFilter,
                    ...payload,
                };
            }
            const res = await teachingCenter.getLessonVerifyResponseList.getList(
                params
            );
            commit("setData", {key: "lessonVerifyResponseList", value: res.data});
        } finally {
            commit("setData", {
                key: "lessonVerifyResponseListLoading",
                value: false,
            });
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async verifyLessonVersion({}, payload) {
        await teachingCenter.verifyLessonVersion(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deployLesson({}, payload) {
        return await teachingCenter.deployLesson(payload);
    },
    async getProductCategoryList({commit}, payload) {
        commit("setData", {key: "productCategoryListLoading", value: true});
        try {
            let params = {
                ...state.productCategoryListFilter,
                ...payload
            };
            let res = await teachingCenter.getProductCategoryList(params);
            commit("setData", {key: "productCategoryList", value: res.data});
            return res;
        } finally {
            commit("setData", {key: "productCategoryListLoading", value: false});
        }
    },
    async getCachedProductCategoryList({commit}) {
        let productCategoryList = state.productCategoryList;
        if (!productCategoryList.length) {
            let res = await teachingCenter.getProductCategoryList({})
            commit("setData", {key: "productCategoryList", value: res.data});
        }
        const list = {id: 0, name: "banner位"};
        return [
            list,
            ...state.productCategoryList
        ];
    },
    async saveProductCategory({commit}, params) {
        return await teachingCenter.saveProductCategory(params);
    },
    async deleteProductCategory({commit}, id) {
        return await teachingCenter.deleteProductCategory(id);
    },
    async deployProductCategory({commit}, id) {
        return await teachingCenter.deployProductCategory(id);
    },
    async moveProductCategory({commit}, params) {
        return await teachingCenter.moveProductCategory(params);
    },
    // eslint-disable-next-line no-empty-pattern
    async getProductResponseList({commit}, payload) {
        commit("setData", {key: "productListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.productListFilter.dateRange &&
                state.productListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.productList.size,
                    ...state.productListFilter,
                    ...payload,
                    startTime: state.productListFilter.dateRange
                        ? state.productListFilter.dateRange[0]
                        : null,
                    endTime: state.productListFilter.dateRange
                        ? state.productListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.productList.size,
                    ...state.productListFilter,
                    ...payload,
                };
            }
            const res = await teachingCenter.getProductResponseList.getList(params);
            commit("setData", {key: "productList", value: res.data});
        } finally {
            commit("setData", {key: "productListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getProductMapList({}, payload) {
        return await teachingCenter.getProductResponseList.getList(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async moveProduct({}, payload) {
        // 为了处理 过滤参数和分页器参数
        if (state.productListFilter.dateRange) {
            payload.startTime = state.productListFilter.dateRange
                ? state.productListFilter.dateRange[0]
                : null;
            payload.endTime = state.productListFilter.dateRange
                ? state.productListFilter.dateRange[1]
                : null;
        }
        await teachingCenter.moveProduct(payload);
    },
    // 课包题库
    // eslint-disable-next-line no-empty-pattern
    async getProductQuestionBankList({commit}, payload) {
        commit("setData", {key: "productListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.productListFilter.dateRange &&
                state.productListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.productList.size,
                    ...state.productListFilter,
                    ...payload,
                    startTime: state.productListFilter.dateRange
                        ? state.productListFilter.dateRange[0]
                        : null,
                    endTime: state.productListFilter.dateRange
                        ? state.productListFilter.dateRange[1]
                        : null,
                    type: 1,
                };
            } else {
                params = {
                    size: state.productList.size,
                    type: 1,
                    ...state.productListFilter,
                    ...payload,
                };
            }
            const res = await teachingCenter.getProductResponseList.getList(params);
            commit("setData", {key: "productList", value: res.data});
        } finally {
            commit("setData", {key: "productListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveProduct({}, payload) {
        await teachingCenter.saveProduct(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveProductAutoUp({}, payload) {
        await teachingCenter.saveProductAutoUp(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deployProduct({}, payload) {
        await teachingCenter.deployProduct(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteProduct({}, payload) {
        await teachingCenter.deleteProduct(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getLessonUpperPassResponseList({commit}, payload) {
        commit("setData", {key: "courseListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.courseListFilter,
                ...payload,
                size: 10,
            };
            const res = await teachingCenter.getLessonUpperPassResponseList.getList(
                params
            );
            commit("setData", {key: "courseList", value: res.data});
        } finally {
            commit("setData", {key: "courseListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getExamList({commit}, payload) {
        commit("setData", {key: "examListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                size: 10,
                ...state.examListFilter,
                ...payload,
                deployed: true,
            };
            const res = await pluginCenter.getTestPaperList.getList(params);
            commit("setData", {key: "examList", value: res.data});
        } finally {
            commit("setData", {key: "examListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async getProductSubjectContentList({commit}, payload) {
        commit("setData", {key: "subjectContentListLoading", value: true});
        try {
            // 为了处理 过滤参数和分页器参数
            const params = {
                ...state.subjectContentListFilter,
                ...payload,
                size: 1000,
            };
            const res = await teachingCenter.getProductSubjectContentList.getList(
                params
            );
            commit("setData", {key: "subjectContentList", value: res.data});
        } finally {
            commit("setData", {key: "subjectContentListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveCustomSubject({}, payload) {
        return await teachingCenter.saveCustomSubject(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async saveCustomSubjectMirror({}, payload) {
        return await teachingCenter.saveCustomSubjectMirror(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTagValueList({commit}, payload) {
        commit("setData", {key: "tagListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.tagListFilter.dateRange &&
                state.tagListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.tagList.size,
                    ...state.tagListFilter,
                    ...payload,
                    startTime: state.tagListFilter.dateRange
                        ? state.tagListFilter.dateRange[0]
                        : null,
                    endTime: state.tagListFilter.dateRange
                        ? state.tagListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.tagList.size,
                    ...state.tagListFilter,
                    ...payload,
                };
            }
            const res = await teachingCenter.getTagValueList.getList(params);
            commit("setData", {key: "tagList", value: res.data});
        } finally {
            commit("setData", {key: "tagListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTagValue({}, payload) {
        return await teachingCenter.saveTagValue(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTagValue({}, payload) {
        return await teachingCenter.deleteTagValue(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async getTagCategoryList({commit}, payload) {
        commit("setData", {key: "tagCategoryListLoading", value: true});
        try {
            var params = {};
            // 为了处理 过滤参数和分页器参数
            if (
                state.tagCategoryListFilter.dateRange &&
                state.tagCategoryListFilter.dateRange.length === 2
            ) {
                params = {
                    size: state.tagCategoryList.size,
                    ...state.tagCategoryListFilter,
                    ...payload,
                    startTime: state.tagCategoryListFilter.dateRange
                        ? state.tagCategoryListFilter.dateRange[0]
                        : null,
                    endTime: state.tagCategoryListFilter.dateRange
                        ? state.tagCategoryListFilter.dateRange[1]
                        : null,
                };
            } else {
                params = {
                    size: state.tagCategoryList.size,
                    ...state.tagCategoryListFilter,
                    ...payload,
                };
            }
            const res = await teachingCenter.getTagCategoryList.getList(params);
            commit("setData", {key: "tagCategoryList", value: res.data});
        } finally {
            commit("setData", {key: "tagCategoryListLoading", value: false});
        }
    },
    // eslint-disable-next-line no-empty-pattern
    async saveTagCategory({}, payload) {
        return await teachingCenter.saveTagCategory(payload);
    },
    // eslint-disable-next-line no-empty-pattern
    async deleteTagCategory({}, payload) {
        return await teachingCenter.deleteTagCategory(payload);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
